import { I18nState } from './i18n.state';
export class NgxTranslateAdapterLoader {
  constructor(store) {
    this.store = store;
  }
  // NOTE: the way ngx-translate loaders are implemented requires us to use a dirty workaround.
  // getTranslation can only respond a single time and ngx-translate has no good reload mechanism available.
  // But we need to fetch translation 2x: 
  // - immediately available baked-in core translations
  // - fetched-from-server translations
  getTranslation(lang) {
    // lang argument will be ignored because i18nState acts as master and loader/ngx-translate as slave.
    // console.log('re-load trabnslation from store , state at moment of selection',this.store.snapshot().i18n)
    return this.store.selectOnce(I18nState.selectedLanguageData);
  }
}